module.exports = __webpack_public_path__ + "img/dsci0047.d74cb4f9.jpg";